import i18n from 'services/base/i18n';

export default {
  anyProtocol: () => i18n.pgettext('Components|List History|Filter History|Protocol Input|Port Input', 'Any'),
  portPrompt:  () => i18n.pgettext('Components|List History|Filter History|Protocol Input|Port Input', 'Enter Port Number'),
};
